export function initAccordion(swiper) {
  const accordionItems = document.querySelectorAll(".accordion__item");

  accordionItems.length &&
    accordionItems.forEach((item, index) => {
      item.addEventListener("click", () => {
        accordionItems.forEach((otherItem, otherIndex) => {
          if (otherIndex !== index) {
            otherItem.classList.remove("active");
          }
        });
        item.classList.toggle("active");

        swiper.slideTo(index);
      });
    });
}

export function initAccordionProblems() {
  const accordionItems = document.querySelectorAll(".problems-accordion__item");

  accordionItems.length &&
    accordionItems.forEach((item, index) => {
      item.addEventListener("click", () => {
        accordionItems.forEach((otherItem, otherIndex) => {
          if (otherIndex !== index) {
            otherItem.classList.remove("active");
          }
        });
        item.classList.toggle("active");
      });
    });
}

export function initGlobalAccordion() {
  const accordions = document.querySelectorAll(".accordion");

  if (!accordions.length) return;

  accordions.forEach(() => {
    const accordionItems = document.querySelectorAll(".accordionItem");

    accordionItems.length &&
      accordionItems.forEach((item) => {
        const btn = item.querySelector(".accordionButton");

        btn.addEventListener("click", ({ target }) => {
          console.log(target);
          const currentItem = btn.closest(".accordionItem");

          accordionItems.forEach((item) => {
            if (item !== currentItem) {
              item.classList.remove("active");
            }
          });

          currentItem.classList.toggle("active");
        });
      });
  });
}
